<div class="w-100 h-100">
    <div class="row" style="padding-top: 56px;">
        <div class="col-md-12">
            <div class="form-row justify-content-between align-items-baseline">
                <div class="col-auto">
                    <label class="header_text mb-3">
                        {{$t('shared.updateDataRequests')}}
                    </label>
                </div>
            </div>
        </div>
    </div>
    <div class="row row-table">
        <div class="col-md-12">
            <div class="card card_layout">
                <div class="card-header ur-card-header">
                    <div class="form-row justify-content-between align-items-center w-100">
                        <div class="col-auto">
                            <label class="card_header_text">
                                <i class="fas fa-sync-alt reload" @click="reload()"></i>
                                {{$t('updateDataRequestsPage.requests')}} ({{sendersCount}})
                            </label>
                        </div>
                        <div class="col-auto">
                            <button v-if="userRole == 2 || userRole == 5" @click="newRequest()" class="btn btn-primary btn-action">
                                {{$t('dashboardPage.newRequest')}} <i class="fas fa-plus px-2"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="card-body ur-card-body">
                    <template>
                        <div class="row">
                            <div class="col-md-3">
                                <div class="input-group mb-3">
                                    <input class="form-control border-right-0 border-left"
                                           type="text"
                                           v-model="filterModel.displayId"
                                           :placeholder="$t('updateDataRequestsPage.requestId')" />
                                    <div class="input-group-append">
                                        <span class="input-group-text right gray">
                                            <i class="fas fa-search"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="input-group mb-3">
                                    <input class="form-control border-right-0 border-left"
                                           type="text"
                                           v-model="filterModel.clientName"
                                           :placeholder="$t('updateDataRequestsPage.clientName')" />
                                    <div class="input-group-append">
                                        <span class="input-group-text right gray">
                                            <i class="fas fa-search"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="input-group mb-3">
                                    <input class="form-control border-right-0 border-left"
                                           type="text"
                                           v-model="filterModel.senderName"
                                           :placeholder="$t('dashboardPage.senderNameSearch')" />
                                    <div class="input-group-append">
                                        <span class="input-group-text right gray">
                                            <i class="fas fa-search"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <v-select v-model="filterModel.status"
                                          :items="statusOptions"
                                          :label="$t('updateDataRequestsPage.status')"
                                          item-text="name"
                                          item-value="id"
                                          :clearable="true"
                                          solo>
                                </v-select>
                            </div>
                        </div>
                        <v-data-table :headers="headers"
                                      :items="senders"
                                      :total-items="sendersCount"
                                      :pagination.sync="pagination"
                                      :rows-per-page-text="$t('shared.rowsPerPage')"
                                      :rows-per-page-items='[10, 25, 50, 100]'
                                      @update:pagination="updatePaginate"
                                      item-key="id"
                                      class="elevation-1 table-striped">
                            <template v-slot:headers="props">
                                <tr>
                                    <th v-for="header in props.headers"
                                        :key="header.text"
                                        :class="['column', header.sortable ? 'sortable':'', header.sortable ? pagination.descending ? 'desc' : 'asc': '', header.value === pagination.sortBy ? 'active' : '',
                                        header.align === 'center' ? 'text-center' : header.align === 'right' ? 'text-right' : 'text-left' ]"
                                        @click="changeSort(header.value)" :width="header.width !== ''? header.width : '' ">
                                        <v-icon v-if="header.sortable" small>arrow_upward</v-icon>
                                        {{ header.text }}
                                    </th>
                                </tr>
                            </template>
                            <template v-slot:items="props">
                                <tr>
                                    <td class="text-center">{{ props.item.displayId }}</td>
                                    <td class="text-center">{{ props.item.clientName }}</td>
                                    <td class="text-center">{{ props.item.senderName }}</td>
                                    <td class="text-center">
                                        <span v-for="(st, idx) in fillSenderTypes(props.item.senderType)" :key="idx">
                                            {{ getSenderTypeText(st) }}<span v-if="idx < fillSenderTypes(props.item.senderType).length - 1">, </span>
                                        </span>
                                    </td>
                                    <td class="text-center">{{ props.item.requestStatus }}</td>
                                    <td class="text-center">{{ props.item.createdDate }}</td>
                                    <td class="text-center btn_menu">
                                        <template v-if="(userRole == 1 || userRole == 9 || userRole == 15) && props.item.requestStatusId == 1">
                                            <v-menu offset-y open-on-hover>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn color="btn-primary" v-on="on">
                                                        <div>{{$t('shared.actions')}}</div>
                                                        <i class="fas fa-chevron-down pl-4" style="vertical-align: sub;"></i>
                                                    </v-btn>
                                                </template>
                                                <v-list>
                                                    <v-list-tile @click="showApproveDialog(props.item.id)">
                                                        <v-list-tile-title class="white">
                                                            {{$t('dashboardPage.Approve')}}
                                                        </v-list-tile-title>
                                                    </v-list-tile>
                                                    <v-list-tile @click="showRejectDialog(props.item.id)">
                                                        <v-list-tile-title class="white">
                                                            {{$t('dashboardPage.reject')}}
                                                        </v-list-tile-title>
                                                    </v-list-tile>
                                                    <v-list-tile @click="viewDetails(props.item.id)">
                                                        <v-list-tile-title class="white">
                                                            {{$t('shared.details')}}
                                                        </v-list-tile-title>
                                                    </v-list-tile>
                                                </v-list>
                                            </v-menu>
                                        </template>
                                        <v-btn v-else-if="userRole == 2 || userRole == 5"
                                               class="ur-icon-btn"
                                               color="btn-primary"
                                               :title="$t('shared.view')"
                                               @click="viewDetails(props.item.id)">
                                            <i class="fas fa-eye"></i>
                                        </v-btn>
                                        <v-btn v-else color="btn-primary" @click="viewDetails(props.item.id)">
                                            <div>
                                                {{$t('shared.details')}}
                                                <i class="fas fa-info-circle pl-2"></i>
                                            </div>
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </template>
                </div>
            </div>
        </div>
    </div>

    <div class="text-xs-center">
        <v-dialog v-model="approveDialog" width="554">
            <v-card class="ur-confirm-dialog">
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('shared.approveInput')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideApproveDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text class="text-center">
                    <p>{{$t('updateDataRequestsPage.approveConfirm')}}</p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <button class="btn btn-outline-secondary px-5 py-2" @click="hideApproveDialog">
                                {{$t('shared.no')}}
                            </button>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" @click="confirmApprove">
                                {{$t('shared.yes')}}
                            </button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>

    <div class="text-xs-center">
        <v-dialog v-model="rejectDialog" persistent width="554">
            <v-card class="ur-confirm-dialog">
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('dashboardPage.reject')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideRejectDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text>
                    <p class="text-center">{{$t('updateDataRequestsPage.rejectConfirm')}}</p>
                    <div class="row mt-3">
                        <div class="col-md-12">
                            <div class="form-group mb-0">
                                <label>{{$t('dashboardPage.rejectreason')}}</label>
                                <input class="form-control" v-model="rejectReason" type="text" />
                            </div>
                        </div>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <button class="btn btn-outline-secondary px-5 py-2" @click="hideRejectDialog">
                                {{$t('shared.no')}}
                            </button>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2"
                                    :disabled="!rejectReasonIsValid"
                                    @click="confirmReject">
                                {{$t('shared.yes')}}
                            </button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</div>
